app.namespace('map');

app.map = (function ($) {    
    function init() {
		var map;
		var isDraggable = $(document).width() > 480 ? true : false;		
		var latLang = {lat: 51.507214, lng:  -0.131728};

		map = new google.maps.Map(document.getElementById('map'), {
			center: latLang,
			zoom: 16,
			scrollwheel: false,
			draggable: isDraggable,
			styles: [
				{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]}
			]
		});

		var icon = {
			size: new google.maps.Size(71, 71),
			scaledSize: new google.maps.Size(530, 530), // scaled size
		};

		var marker = new google.maps.Marker({
			position: latLang,
			map: map,
			icon: { url: 'static/img/map_marker.png', size: new google.maps.Size(50, 80), scaledSize: new google.maps.Size(50, 80),  optimized: true },
		});

		google.maps.event.addListener(map, 'click', function(event){
			this.setOptions({scrollwheel:true, draggable: true});
		});
    }

    return {
        init: init
    };
}(jQuery));